var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusIconShipped(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Shipped ",
    id: "Shipped_",
    transform: "translate(-16766 4804)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    id: "Back",
    transform: "translate(16766 -4804)",
    width: 24
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "truck success",
    id: "truck_success",
    transform: "translate(16765.199 -4804.8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.214,1.8a5.414,5.414,0,1,0,5.414,5.414A5.414,5.414,0,0,0,6.214,1.8Zm0,9.229a3.814,3.814,0,1,1,3.814-3.814,3.814,3.814,0,0,1-3.814,3.814Z",
    "data-name": "Path 8341",
    fill: "#ffff",
    fillRule: "evenodd",
    id: "Path_8341"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.558,5.267,5.63,7.62,4.75,6.49a.8.8,0,1,0-1.262.984l1.5,1.92a.8.8,0,0,0,1.25.015l2.56-3.126A.8.8,0,0,0,7.558,5.267Z",
    "data-name": "Path 8342",
    fill: "#ffff",
    fillRule: "evenodd",
    id: "Path_8342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6,4.2h-.8a.8.8,0,0,0,0,1.6h.8V20.2h-.8a.8.8,0,0,0,0,1.6h1.6a.8.8,0,0,0,.8-.8V5.8A1.6,1.6,0,0,0,13.6,4.2Z",
    "data-name": "Path 8343",
    fill: "#ffff",
    fillRule: "evenodd",
    id: "Path_8343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,18.2a2.8,2.8,0,0,0-2.684,2H3.2V13a.8.8,0,1,0-1.6,0v8a.8.8,0,0,0,.8.8H5.716A2.8,2.8,0,1,0,8.4,18.2Zm0,4A1.2,1.2,0,1,1,9.6,21,1.2,1.2,0,0,1,8.4,22.2Z",
    "data-name": "Path 8344",
    fill: "#ffff",
    fillRule: "evenodd",
    id: "Path_8344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8,16.4a1.6,1.6,0,0,0-.172-.737L21.707,9.877A1.6,1.6,0,0,0,20.278,9H16.8a.8.8,0,1,0,0,1.6h3.477l2.923,5.79V20.2H21.484a2.8,2.8,0,1,0,0,1.6H24a.8.8,0,0,0,.8-.8Zm-6,5.8A1.2,1.2,0,1,1,20,21,1.2,1.2,0,0,1,18.8,22.2Z",
    "data-name": "Path 8345",
    fill: "#ffff",
    fillRule: "evenodd",
    id: "Path_8345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,17a.8.8,0,0,0,0-1.6H4.8a.8.8,0,0,0,0,1.6Z",
    "data-name": "Path 8346",
    fill: "#ffff",
    fillRule: "evenodd",
    id: "Path_8346"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconShipped);
export default __webpack_public_path__ + "static/media/status_icon_shipped.928f2a7d46295c274cf61da7160f0201.svg";
export { ForwardRef as ReactComponent };